import axiosInstance from '../lib/axios';

export const masterService = {
  getStates: () => axiosInstance.get('/masters/state'),
  getDistricts: (stateCode?: string) =>
    axiosInstance.get('/masters/districts', {
      params: stateCode ? { state_code: stateCode } : {},
    }),

  getPoliceSations: (districtId?: string) =>
    axiosInstance.get('/masters/police-stations', {
      params: districtId ? { district_id: districtId } : {},
    }),

  getCaseTypes: () => axiosInstance.get('/masters/case-types'),

  getCaseStatuses: () => axiosInstance.get('/masters/case-statuses'),

  getFinalReportStatuses: () => axiosInstance.get('/masters/final-report-statuses'),

  getFolderTypes: () => axiosInstance.get('/masters/folder-types'),

  getCmsCases: () => axiosInstance.get('/masters/cms-cases'),

  getDocumentTypes: (folderType: string) =>
    axiosInstance.get('/masters/document-types', {
      params: { folder_type: folderType },
    }),

  getContentManagers: () =>
    axiosInstance.get('/masters/content-managers'),
};

export default masterService;
